export default "__VITE_ASSET__22f74dd4__"